import type { z } from "zod";
import { playlistWithSongsSchema } from "@libs/wire";
import type { RouterOutputs } from "@utils/trpc";

/**
 * Compile-time drift check — `playlistWithSongsSchema` matches the wire
 * shape returned from `catalog.playlists.getById` (one element of the
 * array). The forward direction catches "schema is missing fields the
 * router has"; the backward direction catches "schema is narrower than
 * the router output". See useLibrary/queryFunctions.ts for the rationale.
 */
type PlaylistGetByIdElement =
  RouterOutputs["catalog"]["playlists"]["getById"][number];
type _PlaylistWireSchemaSubset =
  z.infer<typeof playlistWithSongsSchema> extends PlaylistGetByIdElement
    ? true
    : never;
type _PlaylistWireSchemaSuperset =
  PlaylistGetByIdElement extends z.infer<typeof playlistWithSongsSchema>
    ? true
    : never;
const _playlistWireSchemaDriftCheck: [
  _PlaylistWireSchemaSubset,
  _PlaylistWireSchemaSuperset,
] = [true, true];
void _playlistWireSchemaDriftCheck;

export {
  playlistQuery,
  playlistQueryKey,
} from "../../../data/queries/collections";
